import { Textarea } from '@mantine/core'

// Textarea should inherit Kobo InputBase styles through Mantine internals.
export const TextareaThemeKobo = Textarea.extend({})
